import { createContext, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "./loginContext.js";
import Footer from "../components/dash/footer.js";
import NavBar from "../components/dash/navbar.js";
import SideBar from "../components/dash/sidebar.js";


export const BOsContext = createContext();

//esta es para poder exportar todo lo que indicamos en values
export const useDashboard = () => {
    const context = useContext(BOsContext);
    if (!context) {
        throw new Error("useAuth must be used within a AuthProvider");
    } else {
        return context;
    }
};

//la forma de poder pasar datos entre vistes es creando este context, dentro de este tabien se pueden definir funciones para agregar,editar y asi, para esta manera de una vez cachar dichos datos.
export const BOsPlantilla = ({ children }) => {

    const { setUser_autenticado, user_autenticado,user } = useAuth();
    const [apartados, setApartados] = useState([]);
    let location = useLocation();


    const get_url_params = () => {
        var url_actula = window.location;
        var valores = (url_actula.href).split("?")[1];
        const urlParams = new URLSearchParams(valores);
        var data = urlParams.get('tbl');
        //console.log(data);
        //console.log(window.location.origin+"/only/exp?data="+data);
        if (data === null) {

            return null;

        } else {
            return data;
        }
    }

    const cambio_hash = (route) => {
        if (route.includes("/")) {
            setApartados("login");
        }
        if (route.includes("/login")) {
            setApartados("login");
        }
        if (route.includes("/home")) {
            setApartados("home");
        }
        if (route.includes("/panel-control")) {
            setApartados("panel-control");
        }

        if (route.includes("/tablero")) {

            var result_params = get_url_params();
           //console.log("tablero" + result_params);
            setApartados("tablero" + result_params);

        }
    }


    useEffect(() => {
       //console.log("ruta: ", location.pathname);
        cambio_hash(location.pathname);

    }, [location]);

    if (user_autenticado && user !== null) {
        return (
            <BOsContext.Provider value={{
                apartados,
                get_url_params,
                setApartados
            }}>
                <NavBar />
                <div className="p-0">
                    <SideBar />
                    <div className=" p-0">
                        <main className=" p-0">
                            {children}
                        </main>
                        <Footer />
                    </div>
                </div>
            </BOsContext.Provider>
        )
    } else {
        return (
            <BOsContext.Provider value={
                {
                    apartados,
                    get_url_params
                }
            }>
                {/**<NavBar />*/}

                <div className="h-100 p-0">
                    {/**<SideBar />*/}
                    <div className="h-100 p-0">
                        <main className="h-100 p-0 bg-dark-subtle">
                            {children}
                        </main>
                    </div>
                </div>
            </BOsContext.Provider>
        )
    }




}